import React from 'react';
import PropTypes from 'prop-types';

import { Panel } from 'react-bootstrap';

import EmptyState from 'components/importer/empty_state';
import PanelHeader from 'components/importer/panel_header';
import ImportsTable from './table/imports_table';

export default function ImportsList({ imports, onNewImport }) {
  const renderHeader = () => (
    <PanelHeader className="justify-content-between">
      <h3>Imports</h3>
      <button className="btn btn-create" name="new-import" onClick={onNewImport}>
        New Import
      </button>
    </PanelHeader>
  );

  const renderBody = () => {
    if (imports.length > 0) {
      return <ImportsTable imports={imports} />;
    }
    return <EmptyState onStartNewImport={onNewImport}/>;
  };

  return (
    <React.Fragment>
      {renderHeader()}
      <Panel className="p-5">
        <Panel.Body>
          {renderBody()}
        </Panel.Body>
      </Panel>
    </React.Fragment>
  );
}

ImportsList.propTypes = {
  imports: PropTypes.array.isRequired,
  onNewImport: PropTypes.func.isRequired
};
